<template>
  <div
    class="border-gray-200 text-center text-sm font-medium dark:border-gray-700"
  >
    <ul class="mb-5 flex list-none flex-row flex-wrap border-b-0 pl-0 md:gap-4">
      <li
        v-for="floor in floors"
        :key="'floorTab_' + floor"
        :class="{ 'font-bold': floorLevel === floor }"
      >
        <span @click="selectFloorTab(floor)">{{ floor }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, WritableComputedRef } from 'vue';
import { DeviceGroup } from '@/components/Forms/DeviceFormComponents/AdvancedRegistraionMeter/DeviceGroup.vue';
import { useInstallationPointStore } from '@/store/entities/installationPointStore';

const emits = defineEmits(['update:selectedFloorLevel']);
const props = defineProps<{
  deviceGroups: DeviceGroup[];
  selectedFloorLevel: string;
}>();

const floors = computed(() => {
  return [
    ...new Set(
      props.deviceGroups.map((element) => {
        return element.name;
      })
    ),
  ].sort();
});

const floorLevel: WritableComputedRef<string> = computed({
  get() {
    return props.selectedFloorLevel;
  },
  set(value) {
    emits('update:selectedFloorLevel', value);
  },
});
const selectFloorTab = (floor: string) => {
  floorLevel.value = floor;
};
</script>
